import { Authentication } from '@/api'

const api = new Authentication();


export default {

  login({ state }, param) {
    return new Promise((resolve, reject) => {
      api.login(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },

  forgetPassword({ state }, param) {
    return new Promise((resolve, reject) => {
      api.forgetPassword(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    });
  }
}



// WEBPACK FOOTER //
// ./src/Auth/store/actions.js